import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import PageIntro from '../components/PageIntro';
import { usePageMeta, SITE_NAME } from '../lib/usePageMeta';

const emails = [
  { email: 'gajendrajha7@gmail.com', label: 'General questions' },
  { email: 'megajendrajha@gmail.com', label: 'Support' },
];

const reasons = [
  'General inquiries',
  'Educational support',
  'Dictionary and word meaning questions',
  'Content suggestions',
  'Reporting an error',
  'Partnership or collaboration opportunities',
  'Feedback to improve the site',
];

const ContactUs = () => {
  const [copied, setCopied] = useState('');

  usePageMeta(
    `Contact Us | ${SITE_NAME}`,
    'Contact Definitionofthe.com with questions, corrections, content suggestions or partnership ideas.'
  );

  const handleCopy = (email) => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(email);
      setTimeout(() => setCopied(''), 2000);
    });
  };

  return (
    <div className="wrap pt-12 md:pt-16">
      <PageIntro title="Contact us">
        Questions, corrections or ideas for a word we should explain better: write to us and we usually reply
        within 24 to 48 hours.
      </PageIntro>

      <ul className="mt-12 max-w-2xl divide-y divide-rule border-y border-rule">
        {emails.map(({ email, label }) => (
          <li key={email} className="flex flex-col gap-3 py-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0">
              <p className="text-[0.95rem] text-ink-soft">{label}</p>
              <a href={`mailto:${email}`} className="break-all font-serif text-xl text-ink decoration-mark decoration-4 underline-offset-4 hover:underline">
                {email}
              </a>
            </div>
            <div className="flex shrink-0 gap-2">
              <a
                href={`mailto:${email}`}
                className="inline-flex h-10 items-center rounded-md bg-ink px-4 text-[0.95rem] font-medium text-paper transition-colors hover:bg-ink/85"
              >
                Write an email
              </a>
              <button
                type="button"
                onClick={() => handleCopy(email)}
                className="inline-flex h-10 items-center gap-1.5 rounded-md border border-rule px-4 text-[0.95rem] font-medium text-ink transition-colors hover:border-ink"
              >
                {copied === email ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
                {copied === email ? 'Copied' : 'Copy address'}
              </button>
            </div>
          </li>
        ))}
      </ul>

      <section className="mt-14 max-w-2xl">
        <h2 className="font-serif text-2xl font-semibold">What you can write to us about</h2>
        <ul className="mt-4 list-disc space-y-2 pl-5 marker:text-ink-soft">
          {reasons.map((reason) => <li key={reason}>{reason}</li>)}
        </ul>
      </section>
    </div>
  );
};

export default ContactUs;
